<template>
  <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12">
            <div class="card">
              <div class="card-header">
                <i class="fa fa-align-justify"></i> Jira Projects
              </div>
              <div class="card-block">
                <div v-if="spinners.contentIsLoading" class="text-center">
                  <b-spinner type="grow" variant="primary"/>
                </div>
                <div v-else>
                  <b-row>
                    <b-col cols="12">

                        <b-form @submit.prevent="getData">
                          <b-row>
                            <b-col cols="2">
                              <b-form-group>
                                <b-form-input v-model="filter.key" placeholder="Project key"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col cols="4">
                              <b-form-group>
                                <b-form-input v-model="filter.name" placeholder="Project name"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col cols="1">
                              <b-button type="submit"  variant="success">Submit</b-button>
                            </b-col>
                          </b-row>
                        </b-form>

                    </b-col>
                    <b-col cols="12">
                      <b-table
                        hover
                        small
                        class="pointer"
                        responsive
                        :fields="tableFields"
                        :items="tableItems"
                        @row-clicked="jiraIssueSearch"
                      >
                        <template v-slot:cell(auto_import)="row">
                          <a v-if="row.item.jira_import_enabled" class="mr-1>">
                            <span class="badge badge-success">Enabled</span>
                          </a>
                          <a v-if="!row.item.jira_import_enabled" class="mr-1">
                            <span class="badge badge-danger">Disabled</span>
                          </a>
                        </template>
                        <template v-slot:cell(options)="row">
                         <!-- <a v-if="!row.item.jira_import_enabled" class="mr-1"
                             @click="jiraProjectToggle(row.item.id, true)">
                            <i class="fa fa-unlock-alt fa-lg fa-success"/>
                          </a>
                          <a
                            v-if="row.item.jira_import_enabled" class="mr-1"
                            @click="jiraProjectToggle(row.item.id, false)"
                          >
                            <i class="fa fa-ban fa-lg fa-danger"/>
                          </a>-->
                          <router-link
                            :to="{ name: 'ProjectTabPlanning', params: {id: row.item.id } }"
                          >
                                <i class="fa fa-external-link fa-lg"/>
                          </router-link>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                  <b-row>
                    <!--Paginator-->
                    <b-col cols="12" v-if="tableItems.length">
                      <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import statuses from '../../../store/statuses';
import JiraTypes from '@/store/modules/Jira/types';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      filter: {
        project_lead_id: '',
        key: '',
        name: '',
      },
      spinners: {
        contentIsLoading: true,
      },
      row: {},
      tableFields: [
        { key: 'id', label: 'id' },
        { key: 'key', label: 'Key' },
        { key: 'name', label: 'Name' },
        { key: 'projectTypeKey', label: 'Type' },
        { key: 'last_imported_parsed', label: 'Last imported' },
        { key: 'last_imported_issues_parsed', label: 'Entities imported' },
        // { key: 'auto_import', label: 'Status' },
        {
          key: 'options',
          label: 'options',
        }
      ],
      tableItems: [],
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('Jira', [
      'jiraProjects',
      'jiraProjectsUpdate',
    ]),
    ...mapGetters('JiraProjects', [
      'projectSelectedLead',
    ]),
    listPaginator() {
      return this.jiraProjects.data.meta;
    },
    list() {
      return this.jiraProjects;
    },
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        if (this.list['status'] === statuses.LOADED) {
          this.tableItems = this.list.data.data || [];
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    jiraProjectsUpdate: {
      handler: function () {
        if (this.jiraProjectsUpdate.status === statuses.LOADED) {
          // this.alertSuccess();
          this.getData();
        } else if (this.jiraProjectsUpdate.status === statuses.ERROR) {
          // this.alertError();
        }
      },
      deep: true
    },
    projectSelectedLead: {
      handler: function () {
        this.getData();
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Jira', [
      JiraTypes.JIRA_PROJECTS,
      JiraTypes.JIRA_PROJECTS_UPDATE,
    ]),
    getData() {
      this.filter.project_lead_id = this.projectSelectedLead.project_lead_id;

      const page = this.page;
      const filter = this.filter;
      this.JIRA_PROJECTS({ page, filter });
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'ApplyJiraProjects', params: { page } });
      }
    },
    jiraIssueSearch(record, index) {
      this.$router.push({
        name: 'ApplyJiraProjectIssues',
        params: {
          project_key: record.key
        }
      });
    },
    jiraProjectToggle(id, isActive) {
      this.JIRA_PROJECTS_UPDATE({ id, isActive });
    },
  }
};
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
